/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChargeCategoryResponseDto } from '../models/ChargeCategoryResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChargeCategoriesService {
    /**
     * List active charge categories for sales
     * @returns ChargeCategoryResponseDto
     * @throws ApiError
     */
    public static chargeCategoriesControllerFindAllActive(): CancelablePromise<Array<ChargeCategoryResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/charge-categories',
        });
    }
}
